module.exports = __webpack_public_path__ + "img/logo.f4650ed4.png";